import { scpConfigService } from "../services/scpConfigService";

import { show as showAlert } from "../../Notifications/actions/alert.actions";

import { message } from "../../../constants/app.constants";

import {
  persoFormatCodeConstants,
  nameSpace
} from "../constants/persoFormatCode.constants";

///============Get SCP configuration DATA===============///
export const getPersoFormatCode = persoId => {
  return async dispatch => {
    dispatch(request());
    try {
      const response = await scpConfigService.getAllPersoFormatCode({
        persoId: persoId
      });
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        showAlert(
          "danger",
          "Failed to get selected configuration",
          error ? error.message : message.GENERIC_ERROR
        )
      );
    }
  };
  function request(request) {
    return {
      type: persoFormatCodeConstants[`GET_${nameSpace}_REQUEST`],
      request
    };
  }
  function success(response) {
    return {
      type: persoFormatCodeConstants[`GET_${nameSpace}_SUCCESS`],
      response
    };
  }
  function failure(error) {
    return {
      type: persoFormatCodeConstants[`GET_${nameSpace}_FAILURE`],
      error
    };
  }
};

export const resetPersoConfigs = () => {
  return { type: persoFormatCodeConstants[`GET_${nameSpace}_RESET`] };
}